module.exports = __webpack_public_path__ + "assets/projects/zissel/comparison.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/zissel/comparison.jpg
// module id = 58
// module chunks = 0